import React, { useState } from 'react'
import rdc from '../images/map-interactif.png'
import agency from '../images/agency2.png'
import ScrollTrigger from 'react-scroll-trigger'
import CountUp from 'react-countup';
import { useLang } from "./Provider/LanguageProvider";

function NosAgences() {
  const { language } = useLang();
  const [counterOn, setCounterOn] = useState(false);

  return (
    <div id='nosagences'>
      <div className='gap-marques'></div>
      <section className='section1'>
        {language === 'fr' ?
          <div className='welcome'>
            <span className='pre-title'>NOUS SOMMES LA</span>
            <h1>RÉFÉRENCE N°1 DANS LA <br />
              DISTRIBUTION DE TABAC EN RDC</h1>
            <p>
              Avec plus de 40 points de vente, nous sommes passés d’une entreprise régionale à la plus grande entreprise de distribution de cigarettes dans le pays.
              <br />
              <br />
              Nous distribuons nos produits directement avec notre propre force de vente.
            </p>
          </div> :
          <div className='welcome'>
            <span className='pre-title'>WE ARE THE</span>
            <h1>NUMBER 1 REFERENCE IN TOBACCO DISTRIBUTION IN DRC</h1>
            <p>
              With over 40 points of sale, we have grown from a regional company to the largest cigarette distribution company in the country.
              <br />
              <br />
              We distribute our products directly with our own sales force.
            </p>
          </div>
        }
      </section>
      <section className='section2'>
        <div className='container'>
          {language === 'fr' ?
            <p>
              Grâce à notre large réseau de distribution, nous avons créer une base solide pour permettre
              l’expansion de nos affaires. Nous continuerons à élargir notre présence sur le
              marché local et vendrons nos produits d’une manière responsable et innovante.
            </p> :
            <p>
              Thanks to our extensive distribution network, we have created a solid foundation to enable the expansion of our business.
              We will continue to expand our presence in the local market and sell our products in a responsible and innovative way.
            </p>
          }
          <div className='mid-container'>
            <div className='img-cont' data-aos="fade-up">
              <img src={rdc} alt='rdc map' />
            </div>
            <div className='text-cont'>
              <div className='top-cont'>
                <img src={agency} alt='agency' />
                <div className='text-wrapper'>
                  <h3>
                    SHENIMED BUKAVU
                  </h3>
                  <span>05/06, Avenue des ouvriers
                    BUKAVU</span>
                </div>
              </div>
              <div className='bottom-cont'>
                <div className='location'>
                  <h3>
                    SHENIMED KINSHASA
                  </h3>
                  <span>5273, Avenue Saint-Christophe
                    Q/ FUNA, C/ LIMETE</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED GOMA
                  </h3>
                  <span>Avenue du Lac<br />
                    GOMA</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED BUTEMBO
                  </h3>
                  <span>38, Rue Kinshasa
                    BUTEMBO</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED LUBUMBASHI
                  </h3>
                  <span>2871, Avenue Kamanyola
                    LUBUMBASHI</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED MBUJI MAYI
                  </h3>
                  <span>Commune de Muya
                    MBUJI- MAYI</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED KOLWEZI
                  </h3>
                  <span>57, Avenue Maduda, Q/Biashara, C/Dilala, KOLWEZI</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED KISANGANI
                  </h3>
                  <span>05, Avenue Musibasiba, Q/Commercial, C/Makiso, KISANGANI </span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED MAHAGI
                  </h3>
                  <span>Chefferie de Padanga, Q/Walpalara, C/Mahagi, MAHAGI</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED MBANDAKA
                  </h3>
                  <span>25, Avenue du Congo, Q/Mambenga, C/Mbandaka, MBANDAKA</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED MBANZAGUNGU
                  </h3>
                  <span>25, Avenue MOBUTU, Q/Disengomoka, Ville de MBANZA NGUNGU</span>
                </div>
                <div className='location'>
                  <h3>
                    SHENIMED KIKWIT
                  </h3>
                  <span>16, Avenue Kimbuku, Q/Mateba, C/Ngaba, KIKWIT  </span>
                </div>
                <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                </ScrollTrigger>
                <div className='location special'>
                  <div className='fact-number'>
                    <span className='plussign'>
                      +
                    </span>
                    <span className='num'>
                      {counterOn && <CountUp start={0} end={40} duration={2} delay={0} />}
                    </span>
                  </div>
                  <span className='text'>{language === 'fr' ? 'POINTS DE VENTES' : 'SALE POINTS'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default NosAgences